var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgData = function SvgData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 65 65"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m62.034 53.504-26.363 10.48a8.7 8.7 0 0 1-6.583 0l-26.17-10.48a3.835 3.835 0 0 1 0-7.126l3.993-1.63 19.78 7.925a15.44 15.44 0 0 0 11.377 0l19.972-7.925 4.09 1.63a3.835 3.835 0 0 1-.096 7.126m-26.363-6.775 26.267-10.513a3.835 3.835 0 0 0 0-7.094L35.671 18.609a9 9 0 0 0-6.39 0L2.916 29.121a3.834 3.834 0 0 0 0 7.094L29.28 46.729c2.059.78 4.332.78 6.391 0",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.28 29.473 2.917 18.96a3.835 3.835 0 0 1 0-7.126L29.28 1.353a8.7 8.7 0 0 1 6.391 0l26.267 10.481a3.835 3.835 0 0 1 0 7.126L35.671 29.473a9 9 0 0 1-6.39 0"
  })));
};
export default SvgData;